module.exports = __webpack_public_path__ + "static/fonts/iconfont.4b4cb03.eot";